import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { allCategories } from '@/utils/articles';

const mainLinks = [
  { to: '/', label: '首页', match: (p: string) => p === '/' },
  { to: '/category/feiwen', label: '娱乐黑料', match: (p: string) => p.startsWith('/category') },
  { to: '/news', label: '资讯', match: (p: string) => p.startsWith('/news') },
  { to: '/star', label: '明星专题', match: (p: string) => p.startsWith('/star') },
  { to: '/about', label: '关于我们', match: (p: string) => p.startsWith('/about') },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
    setKeyword('');
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-foreground-950 text-background-50">
      <div className="w-full">
        <div className="max-w-content mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-[72px] gap-4">
            <Link to="/" className="flex items-center gap-2.5 shrink-0">
              <span className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-label font-bold text-lg md:text-xl">
                91
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-lg md:text-xl font-black tracking-tight">91黑料</span>
                <span className="text-[10px] md:text-xs text-background-400 mt-0.5 tracking-widest font-label">
                  HEILIAO NEWS
                </span>
              </span>
            </Link>

            <nav className="hidden lg:flex items-center gap-1">
              {mainLinks.map((link) => {
                const active = link.match(location.pathname);
                return (
                  <Link
                    key={link.to}
                    to={link.to}
                    className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                      active
                        ? 'bg-primary-500 text-background-50'
                        : 'text-background-200 hover:text-background-50 hover:bg-background-800/60'
                    }`}
                  >
                    {link.label}
                  </Link>
                );
              })}
            </nav>

            <div className="flex items-center gap-2">
              <form onSubmit={submitSearch} className="hidden md:flex items-center relative">
                <i className="ri-search-line absolute left-3 text-background-400 text-sm"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索黑料 / 明星"
                  className="w-40 lg:w-52 pl-9 pr-3 py-2 text-sm rounded-md bg-background-800/70 text-background-50 placeholder:text-background-400 border border-background-700/60 focus:outline-none focus:border-primary-400 focus:w-56 transition-all"
                />
              </form>
              <Link
                to="/search"
                aria-label="搜索"
                className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-background-200 hover:text-background-50"
              >
                <i className="ri-search-line text-xl"></i>
              </Link>
              <button
                type="button"
                aria-label="菜单"
                onClick={() => setMenuOpen((v) => !v)}
                className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-background-100 hover:text-background-50"
              >
                <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
              </button>
            </div>
          </div>
        </div>

        <div className="hidden lg:block border-t border-background-800/70">
          <div className="max-w-content mx-auto px-4 md:px-6">
            <div className="flex items-center gap-1 h-10 overflow-x-auto">
              <span className="text-xs text-background-400 font-label mr-2 shrink-0 flex items-center gap-1">
                <i className="ri-fire-line text-primary-400"></i> 分类
              </span>
              {allCategories.map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className={`px-3 py-1.5 text-xs rounded-full whitespace-nowrap transition-colors ${
                    location.pathname === `/category/${cat.key}`
                      ? 'bg-primary-500/90 text-background-50'
                      : 'text-background-300 hover:text-background-50 hover:bg-background-800/70'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-800/70 bg-foreground-950">
          <div className="px-4 py-4 space-y-1">
            <form onSubmit={submitSearch} className="relative mb-3">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-background-400 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索黑料 / 明星"
                className="w-full pl-9 pr-3 py-2.5 text-sm rounded-md bg-background-800/70 text-background-50 placeholder:text-background-400 border border-background-700/60 focus:outline-none focus:border-primary-400"
              />
            </form>
            {mainLinks.map((link) => {
              const active = link.match(location.pathname);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`block px-4 py-3 rounded-md text-sm font-medium ${
                    active ? 'bg-primary-500 text-background-50' : 'text-background-200'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="pt-3 mt-2 border-t border-background-800/70">
              <p className="text-xs text-background-400 font-label mb-2">分类浏览</p>
              <div className="flex flex-wrap gap-2">
                {allCategories.map((cat) => (
                  <Link
                    key={cat.key}
                    to={`/category/${cat.key}`}
                    className="px-3 py-1.5 text-xs rounded-full bg-background-800/70 text-background-200"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}